import { Injectable } from '@angular/core';
import { AppMessageService } from '../../app/services/Messageservice'; 
export type NotifierType = 'default' | 'success' | 'error' | 'warning';

@Injectable({ providedIn: 'root' })
export class NotifierService {
  constructor(private readonly messageService: AppMessageService) {}

  notify(type: NotifierType, message: string, clearPrevious = true): void {
    if (clearPrevious) {
      this.clear();
    }
    this.messageService.add({
      severity: this.mapSeverity(type),
      summary: this.mapSummary(type),
      detail: message,
    });
  }

   clear(key?: string): void {
    this.messageService.clear();
  }

  private mapSeverity(type: NotifierType): string {
    switch (type) {
      case 'success': return 'success';
      case 'error': return 'error';
      case 'warning': return 'warn';
      default: return 'info';
    }
  }

  private mapSummary(type: NotifierType): string {
    switch (type) {
      case 'success': return 'Success';
      case 'error': return 'Error';
      case 'warning': return 'Warning';
      default: return 'Info';
    }
  }
}